import { ChangeTracker, JQueryInput } from "./types";
import { getValue, getOriginalValue, setValue } from "./skyward.ui.controls";
(
    function (skyward, $)
    {
        const classnames = skyward.validation.classnames;

        let globalDirtyOverride: boolean | undefined;

        skyward.changeTracking = skyward.changeTracking || {};

        skyward.changeTracking.getHtmlViewers = function (selector)
        {
            return selector.find(".htmlViewer").not(".js-ignoreIFrameContents");
        }

        const containerHasDirtyFields = function (selector: JQuery, query = "[data-dirty=\"true\"]")
        {
            // exclude elements contained within nested changeTrackingRoots
            return selector.find(query).not(selector.find(".js-changeTrackingRoot").find(query)).length > 0;
        };

        skyward.changeTracking.isDirty = function (selectorArg)
        {
            if (typeof globalDirtyOverride === "boolean")
            {
                return globalDirtyOverride;
            }

            if (selectorArg)
            {
                const selector = $(selectorArg);
                const override = selector.data("dirty-override");
                if (typeof override === "boolean")
                {
                    return override;
                }
                return containerHasDirtyFields(selector);
            }

            return !!document.querySelector("[data-dirty=\"true\"]") ||
                $(".js-changeTrackingRoot").toArray().some(function (root)
                {
                    return $(root).data("dirty-override");
                });
        };

        skyward.changeTracking.overrideGlobalDirtyState = function (override)
        {
            globalDirtyOverride = override;
        };

        const overrideDirtyState = function (selectorArg: JQueryInput, override: boolean | undefined)
        {
            const selector = $(selectorArg);
            if (typeof override === "undefined")
            {
                selector.removeData("dirty-override");
            }
            else
            {
                selector.data("dirty-override", override);
                selector.trigger("notifyDirty");
            }
        };

        const clearDirtyList = function (selectorArg: JQuery, resetValues: boolean)
        {
            if (resetValues)
            {
                resetInputValues(selectorArg);
            }
            selectorArg.find("[data-dirty='true']").attr("data-dirty", "false");
            return Promise.all(skyward.changeTracking.getHtmlViewers(selectorArg).toArray().map(function (iframe)
            {
                return skyward.iframeListener.clearDirtyList(iframe);
            }));
        };

        function resetInputValues(selectorArg: JQuery)
        {
            const elements = selectorArg.find("[data-dirty='true']");
            elements.each(function (this: HTMLElement)
            {
                const element = $(this);
                const originalValue = getOriginalValue(element);
                setValue(element, originalValue);
            });
        }

        skyward.changeTracking.clearDirtyList = function (dovId, frameWindow = window, resetValues = false)
        {
            const selector = dovId ? $(`#${dovId}`, frameWindow.document) : $(frameWindow.document.body);

            return clearDirtyList(selector, resetValues);
        };

        skyward.changeTracking.removeFromDirtyList = function (dirtyValuesToRemove)
        {
            $.each(dirtyValuesToRemove, function ()
            {
                $(this).attr("data-dirty", "false");
            });
        };

        skyward.changeTracking.getChangeTracker = function (selectorArg)
        {
            const selector = $(selectorArg);
            const root = selector.closest(".js-changeTrackingRoot");
            if (root.length === 0)
            {
                return undefined;
            }
            const changeTracker: ChangeTracker =
            {
                isDirty: function () { return skyward.changeTracking.isDirty(root); },
                overrideDirtyState: function (override) { return overrideDirtyState(root, override); },
                clearDirtyList: function (resetValues = false) { return clearDirtyList(root, resetValues); }
            };
            return changeTracker;
        };

        skyward.changeTracking.showDirtyScreenModal = function (onConfirm: () => void)
        {
            return skyward.modalLayer.showWarningDialog(
                "leave this record",
                "You have unsaved data that will be lost if you leave this record.",
                {
                    onConfirm
                });
        };

        const toggleDovDirtyState = function (dov: JQuery, element: JQuery, dirty: boolean)
        {
            const dovId = dov.attr("id")!;

            if (dirty || globalDirtyOverride || dov.data("dirty-override"))
            {
                skyward.dataobjectviewer.enableButtons(dovId);
            }
            else if (!element.is("[data-original-value-invalid]"))
            {
                removeFieldValidation();

                const isInWorkflow = dov.is(".workflowContent");
                const selector = isInWorkflow
                    ? ":is([data-dirty=\"true\"],[data-original-value-invalid])"
                    : "[data-dirty=\"true\"]";

                if (!containerHasDirtyFields(dov, selector))
                {
                    skyward.dataobjectviewer.disableButtons(dovId);
                    removeDovValidation();
                }
            }

            function removeDovValidation()
            {
                dov.find(classnames.errorControl.dot()).removeClass(classnames.errorControl);
                dov.find(classnames.errorText.dot()).not(classnames.persist.dot()).removeClass(classnames.errorText);
                dov.find(classnames.warningControl.dot()).removeClass(classnames.warningControl);
                dov.find(classnames.warningText.dot()).not(classnames.persist.dot()).removeClass(classnames.warningText);

                dov.find(".currentRecordContentBaseError").not(".persist").empty();
                dov.find(".warning-list").empty();
                dov.find(".help").not(classnames.persist.dot()).empty();

                const contentMessageArea = skyward.contentMessageArea.getContentMessageArea(dov.parent());
                contentMessageArea?.resetValidation();
            }

            function removeFieldValidation()
            {
                const contentMessageArea = skyward.contentMessageArea.getContentMessageArea(dov.parent());

                const validationName = element.attr("name");
                if (!validationName)
                {
                    return;
                }
                const visualElements = skyward.validation.getControl(validationName, dov);

                const wasError = visualElements.hasClass(classnames.errorControl);
                const wasWarning = visualElements.hasClass(classnames.warningControl);
                if (!wasError && !wasWarning)
                {
                    return;
                }

                visualElements.removeClass([classnames.errorControl, classnames.warningControl]);
                const helpFields = skyward.validation.getHelpMessage(validationName, dov).find(`.${classnames.errorText},.${classnames.warningText}`).not(classnames.persist.dot());
                helpFields.removeClass([classnames.errorText, classnames.warningText]).empty();
                const labelFields = skyward.validation.getLabel(validationName, dov).filter(`.${classnames.errorText},.${classnames.warningText}`).not(classnames.persist.dot());
                labelFields.removeClass([classnames.errorText, classnames.warningText]);

                if (contentMessageArea)
                {
                    contentMessageArea.modifyValidationCount(-wasError, -wasWarning);
                }
            }
        };

        skyward.changeTracking.setUpChangeTracking = function (selector, optionalCallback)
        {
            const callback = typeof optionalCallback === "function" ? optionalCallback : toggleDovDirtyState;
            $(selector).each(function ()
            {
                const changeTrackingRoot = $(this);

                changeTrackingRoot.on("notifyDirty", function (event)
                {
                    const element = $(event.target);
                    const dirty = element.attr("data-dirty") === "true";
                    callback(changeTrackingRoot, element, dirty);
                });
                changeTrackingRoot.on(
                    "change dirty keyup", "[data-original-value]:not([excludefromdataobjectviewer], .browseSearchBox)",
                    function (event: JQuery.TriggeredEvent<HTMLElement, undefined, any, any> & { trackedChanges?: boolean })
                    {
                        //prevent nested changetracking containers from triggering multiple times
                        if (event.trackedChanges)
                        {
                            return;
                        }
                        event.trackedChanges = true;
                        const element = $(this);
                        let value = getValue(element);
                        let originalValue = getOriginalValue(element);
                        const overrideDirtyStringLogic = element.is("[override-dirty-string-logic]");
                        const ignoreDirtyComparison = element.is("[ignoredirtyfieldcomparison]");

                        if (element.hasClass('multiSelectBackingData'))
                        {
                            value = value.length === originalValue.length && $(value).not(originalValue).length === 0 && $(originalValue).not(value).length === 0;
                            originalValue = true;
                        }
                        else if (element.hasClass('dmsBackingData'))
                        {
                            value = skyward.distinctmultiselecteel.changeTracking(element, value, originalValue);
                            originalValue = true;
                        }
                        else if (element.hasClass("datepicker") && !element.hasClass("relativeDate"))
                        {
                            // For datepicker changetracking, we care about the literal text, not the Date value.
                            value = (element.val() as string).substring(0, 10).trim().replace(/\b0/g, "");
                            originalValue = (element.data("original-value")?.substring(0, 10)) || element.data("originalRelativeDate") || "";
                            originalValue = originalValue.trim().replace(/\b0/g, "");
                        }
                        else if (!overrideDirtyStringLogic && (element.is("input[type=number],input[type=range]") || (element.is("[data-decimal-mask]") && element.hasClass("masked"))))
                        {
                            value = normalizeNumberString(value);
                            originalValue = normalizeNumberString(originalValue);
                        }
                        else
                        {
                            value = stringify(value);
                            originalValue = skyward.extensions.encodeHtml(stringify(originalValue));
                        }

                        let dirty;
                        if (element.hasClass("ckeditor"))
                        {
                            dirty = (window as any).CKEDITOR.instances[element.attr("id")!].checkDirty();
                        }
                        else if (ignoreDirtyComparison)
                        {
                            dirty = false;
                        }
                        else
                        {
                            dirty = value !== originalValue;
                        }
                        element.attr("data-dirty", dirty.toString());

                        callback(changeTrackingRoot, element, dirty);
                    });
            });
        };

        skyward.changeTracking.setIgnoreDirtyFieldComparison = function (element, value)
        {
            element = $(element);
            element.attr("ignoredirtyfieldcomparison", value ? "" : null);
        };

        function stringify(value: any)
        {
            if (value === undefined || value === null)
            {
                return value;
            }
            return String(value);
        }

        function normalizeNumberString(rawValue: any)
        {
            if (rawValue === undefined || rawValue === null)
            {
                return rawValue;
            }

            let numPrefix = "";
            let value = String(rawValue).replace(/,/g, "").trim();

            if (value.startsWith("-"))
            {
                value = value.slice(1);
                numPrefix = "-";
            }

            if (value === "." || value === "")
            {
                return "";
            }

            value = trimLeadingTrailingZeros(value);

            const splitDecimal = /^(\d*)(\.\d*)?$/;
            const parts = value.match(splitDecimal);
            if (parts === null)
            {
                return "";
            }

            const reformatted = "" + (parts[1] || "0") + (parts[2] || ".");
            return numPrefix + reformatted;
        }

        function trimLeadingTrailingZeros(num: string)
        {
            let startSlice = 0;
            let endSlice = num.length;

            while (num[startSlice] === "0")
            {
                startSlice++;
            }
            if (startSlice === endSlice)
            {
                return num;
            }

            if (num.indexOf(".") !== -1)
            {
                while (num[endSlice - 1] === "0")
                {
                    endSlice--;
                }
            }

            return num.slice(startSlice, endSlice);
        }
    }(window.skyward = window.skyward || {}, window.jQuery)
);
